<div class="toggle-container" [ngClass]="{'toggle-true': model}" (click)="toggle()">
    <div class="toggle-button">
        <app-svg-icon name="check" *ngIf="model"></app-svg-icon>
        <app-svg-icon name="close-red" *ngIf="!model"></app-svg-icon>
    </div>
</div>